import React, { Component } from 'react';
import SelectWrap from '../../components/SelectWrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import { handleFieldChange } from "../../Utils";

import API from '../../services/API';

class BidderHourly extends Component {
    constructor() {
        super();

        this.state = {
            report: [],
            requests: {},
            availableSources: [],
            type: '',
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(filters) {
        this.setState({ isLoading: true });

        API.Bidder.getHourly(filters, this.state.type).then(({ report, sources }) => {
            this.setState({ report, availableSources: sources, isLoading: false });
        });
    }

    getTable() {
        const { report, availableSources } = this.state;

        return Object.keys(report).length ?
            <Table data={report} sources={availableSources}/> :
            <p>No Data</p>
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Bidder Hourly"/>
                <SelectWrap
                    values={{ '': 'Total', 'onw': 'Onw' }}
                    label="Type:"
                    name="type"
                    onChange={this.handleFieldChange}
                    value={this.state.type}
                    required
                />
                <Form sources={this.state.availableSources} onSubmit={this.handleSubmit}/>
                {this.getTable()}
            </Container>
        );
    }
}

export default BidderHourly;


// WEBPACK FOOTER //
// ./src/scenes/BidderHourly/index.js